/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Ceiling_LabelInputs */



/**
* | output |
* | --- |
* | "Action limit ceiling" |
*
* @param {Agent_Policy_Ceiling_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_ceiling_label = /** @type {((inputs?: Agent_Policy_Ceiling_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Ceiling_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Obergrenze für das Aktionslimit")
	return /** @type {LocalizedString} */ ("Action limit ceiling")
});